import { ReactNode, useEffect, useState } from 'react';
import {
  RadioCardGroup,
  RadioCardOption,
  RadioCardSizing,
  StackedColumn,
  StackedColumnSpacing,
} from '../../../../../core';
import { QuestionAnswer } from './QuestionAnswer';

export interface QuestionProps {
  description?: ReactNode;
  question: string;
  customAnswers?: string[];
  answer?: string;
  groupName: string;
  validate: boolean;
  onChangeAnswer?: (answer: string) => void;
}

const Question: React.FC<QuestionProps> = (props: QuestionProps) => {
  const [currentAnswer, setCurrentAnswer] = useState<string | undefined>(
    props.answer
  );

  const answers = props.customAnswers ?? Object.values(QuestionAnswer);
  const questionOptions: RadioCardOption[] = answers.map((answer) => {
    return { value: answer, label: answer };
  });

  useEffect(() => {
    if (currentAnswer !== props.answer) {
      setCurrentAnswer(props.answer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.answer]);

  const onChangeAnswer = (answer: string) => {
    if (answer !== currentAnswer) {
      setCurrentAnswer(answer);
      props.onChangeAnswer && props.onChangeAnswer(answer);
    }
  };

  return (
    <StackedColumn spacing={StackedColumnSpacing.Tight}>
      <StackedColumn spacing={StackedColumnSpacing.Wide}>
        <RadioCardGroup
          label={props.question}
          optionalNode={props.description}
          required={true}
          validate={props.validate}
          groupName={props.groupName}
          sizing={RadioCardSizing.Auto}
          radioOptions={questionOptions}
          selectedValue={currentAnswer ?? ''}
          onChange={onChangeAnswer}
        />
      </StackedColumn>
    </StackedColumn>
  );
};

export default Question;
